module.exports = __webpack_public_path__ + "static/media/step3.2de5c653.png";